import OpenableSnackbar from './OpenableSnackbar'
export default OpenableSnackbar
